import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class DeviceService {
  constructor() {}

  isLargeScreen() {
    const width =
      window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (width > 640) {
      return true;
    } else {
      return false;
    }
  }
}
